import React from 'react';
import { isNotDefined, _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const colorVariantToStyleMap = {
  brand: styles.brand,
  accent: styles.accent,
  default: styles.default
};
const sizeToStyleMap = {
  extraSmall: styles.extraSmall,
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
  extraLarge: styles.extraLarge
};

function isString(d) {
  return typeof d === 'string';
}

function Heading(props) {
  const {
    className: classNameFromProps,
    children,
    size = 'medium',
    title: titleFromProps,
    colorVariant = 'default',
    ellipsize,
    ellipsizeContainerClassName
  } = props;
  let title = titleFromProps;

  if (ellipsize && isNotDefined(titleFromProps) && isString(children)) {
    title = children;
  }

  const className = _cs(styles.heading, ellipsize && styles.ellipsize, sizeToStyleMap[size], colorVariantToStyleMap[colorVariant], classNameFromProps);

  const heading = /*#__PURE__*/React.createElement(React.Fragment, null, size === 'extraSmall' && /*#__PURE__*/React.createElement("h5", {
    className: className,
    title: title
  }, children), size === 'small' && /*#__PURE__*/React.createElement("h4", {
    className: className,
    title: title
  }, children), size === 'medium' && /*#__PURE__*/React.createElement("h3", {
    className: className,
    title: title
  }, children), size === 'large' && /*#__PURE__*/React.createElement("h2", {
    className: className,
    title: title
  }, children), size === 'extraLarge' && /*#__PURE__*/React.createElement("h1", {
    className: className,
    title: title
  }, children));

  if (ellipsize) {
    return /*#__PURE__*/React.createElement("div", {
      className: _cs(styles.ellipsizeContainer, ellipsizeContainerClassName)
    }, heading);
  }

  return heading;
}

var Heading$1 = genericMemo(Heading);

export { Heading$1 as default };
//# sourceMappingURL=index.js.map
